module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3e47N"))).then(() => parcelRequire('hEqeo'));